import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import {Toaster} from "react-hot-toast";
import {notify} from "../../utils";
import {deleteDiscountCode, resetDiscountCode} from "../../../api/LeaderPortalApi";
import {positiveNotify} from "../../utils/Notify";
import {useState} from "react";

export const DiscountResetPopUp = ({open, setOpen, id, setLoadingPage}) => {
    const [isLoading, setIsLoading] = useState(false)

    const style = (theme) => ({
        position: 'absolute',
        top: '50%',
        left: '50%',
        padding:0,
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: '10px',
        width:'300px'
    })

    const onSubmit = () => {
        setIsLoading(true)

        resetDiscountCode(id).then( response => {
            setIsLoading(false)
            positiveNotify("کد تخفیف با موفقیت بازنشانی شد.")
            setLoadingPage(prev => !prev)
            setOpen(false)
        }).catch( error => {
            notify(error?.response?.data?.message)
            setIsLoading(false)
        })
    }

    return(
        <Modal
            open={open}
        >
            <Box sx={style } className="rule-width p-0">
                <p className={`text-center mt-5`}>کد تخفیف بازنشانی شود؟</p>

                <div className={`row mx-5 my-4 justify-content-between`}>
                    <button
                        className={`col-4 btn border px-2`}
                        style={{fontWeight: "600"}}
                        onClick={() => setOpen(false)}
                    >انصراف</button>
                    <button className={`col-7 btn btn_discount py-2 p-0`} onClick={onSubmit}>بازنشانی</button>
                </div>

                {isLoading && (
                    <div className="loading-overlay">
                        <div className="loading-content">
                            <div className="spinner"></div>
                            <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                        </div>
                    </div>
                )}
            </Box>
        </Modal>
    )
}